// extracted by mini-css-extract-plugin
export default {"wrapper":"op-z","response":"pp-z","error":"qp-z","disabled":"rp-z","buttons":"sp-z","feedbackQuestionSection":"tp-z","yesNoWrapper":"up-z"};